import * as t from 'io-ts';

import {
  makeEnumRuntimeType,
  RCardIdRef,
  RContactUidRef,
  RConversationIdRef,
} from '../../../../models/api/apiTypes';
import {RAsyncStatus} from '../../../appTypes';
import {RPanelCancelTokenId} from '../../panelCancelTokenId';
import {
  PanelTypesEnum,
  RAccountDetailsPanelId,
  RCalendarsPanelId,
  RContactCardPanelId,
  RContactDetailsPanelId,
  REmlPanelId,
  RMessagePanelId,
  RPanelStateBase,
  RViewerPanelId,
} from '../../panelStateBase';

/*
 * Runtime types.
 */

export enum ContactCardLocationsEnum {
  CALENDAR = 'CALENDAR',
  CALENDAR_NEW_EVENT = 'CALENDAR_NEW_EVENT',
  MESSAGE_VIEWER = 'MESSAGE_VIEWER',
}

export const RContactCardPanelStateDirty = t.intersection([
  RPanelStateBase,
  t.type({
    id: RContactCardPanelId,
    parentPanelId: t.union([
      RViewerPanelId,
      RMessagePanelId,
      REmlPanelId,
      RCalendarsPanelId,
      RAccountDetailsPanelId,
      RContactDetailsPanelId,
    ]),
    type: t.literal(PanelTypesEnum.CONTACT_CARD),
    cancelTokenId: RPanelCancelTokenId,
    selectedContactUid: RContactUidRef,
    location: makeEnumRuntimeType(ContactCardLocationsEnum),
    status: RAsyncStatus,
  }),
  t.partial({
    selectedCardId: RCardIdRef,
    accountStatus: RAsyncStatus,
    conversationIds: t.array(RConversationIdRef),
    conversationStatus: RAsyncStatus,
  }),
]);

/*
 * Types.
 */

export interface ContactCardPanelState extends Readonly<t.TypeOf<typeof RContactCardPanelStateDirty>> {}
export const RContactCardPanelState = t.clean<ContactCardPanelState>(RContactCardPanelStateDirty as any);
